import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';

import { ProjectType } from '../../../graphql/generated/graphql';
import DummyContent from '../../component/primitive/DummyContent';
import { SPACING_UNIT } from '../../constant/spacing';

type Props = ClassAttributes<HTMLElement> & {
  project: Pick<ProjectType, 'title'> | null;
  loading: boolean;
  className?: string;
};

const ProjectTitle = ({ project, loading, className }: Props) => {
  if (loading || !project) {
    return <DummyContent size="h4" className={className} />;
  }

  return (
    <Root variant="h4" color="primary" className={className}>
      {project.title}
    </Root>
  );
};

const Root = styled(Typography)({
  marginBottom: SPACING_UNIT,
});

export default ProjectTitle;
